import { useCallback, useEffect, useState } from "react"

import toastMessages from "stores/toastMessages"
import { ISelectOption } from "components/Select/Select"
import { FilterCategory } from "config/constants"
import { ValuationStatus } from "models/Valuation"
import FinanceService from "services/FinanceService"

export default function useValuationStatusOptions(currentFilterCategory: FilterCategory) {
    const [options, setOptions] = useState<ISelectOption<ValuationStatus>[] | undefined>()
    const fetchOptions = useCallback(async () => {
        try {
            const statuses = await FinanceService.getValuationStatuses()
            if (!statuses) return
            setOptions(statuses.list.map(s => ({ label: s, value: s })))
        } catch (e) {
            toastMessages.showSystemError()
        }
    }, [])

    useEffect(() => {
        if (currentFilterCategory !== FilterCategory.valuationStatus || options) return
        fetchOptions()
    }, [fetchOptions, currentFilterCategory, options])

    return {
        valuationStatusOptions: options,
    }
}
